import React from 'react';
import {
  DiJavascript1, DiHtml5, DiCss3, DiReact, DiNodejsSmall, DiPostgresql, DiGit, DiGithubBadge, DiMongodb, DiMysql
} from 'react-icons/di';
import {
  SiNextdotjs, SiTailwindcss, SiExpress, SiSupabase, SiFirebase, SiVercel, SiTypescript, SiPhp, SiLaravel, SiPrisma
} from 'react-icons/si';
import { FaServer, FaRobot, FaMagic, FaSpaceShuttle, FaCode, FaDatabase, FaCloud, FaCog } from 'react-icons/fa';

const Skills = () => {
  const categories = [
    {
      title: "Frontend",
      icon: <FaCode size={18} />,
      items: [
        { name: "JavaScript", icon: <DiJavascript1 size={26} /> },
        { name: "TypeScript", icon: <SiTypescript size={20} /> },
        { name: "React", icon: <DiReact size={26} /> },
        { name: "Next.js", icon: <SiNextdotjs size={20} /> },
        { name: "Tailwind CSS", icon: <SiTailwindcss size={20} /> },
        { name: "HTML5", icon: <DiHtml5 size={26} /> },
        { name: "CSS3", icon: <DiCss3 size={26} /> },
      ]
    },
    {
      title: "Backend",
      icon: <FaDatabase size={18} />,
      items: [
        { name: "Node.js", icon: <DiNodejsSmall size={26} /> },
        { name: "Express", icon: <SiExpress size={20} /> },
        { name: "Laravel", icon: <SiLaravel size={20} /> },
        { name: "PHP", icon: <SiPhp size={20} /> },
        { name: "PostgreSQL", icon: <DiPostgresql size={26} /> },
        { name: "MySQL", icon: <DiMysql size={26} /> },
        { name: "MongoDB", icon: <DiMongodb size={26} /> },
      ]
    },
    {
      title: "Cloud & BaaS",
      icon: <FaCloud size={18} />,
      items: [
        { name: "Firebase", icon: <SiFirebase size={20} /> },
        { name: "Supabase", icon: <SiSupabase size={20} /> },
        { name: "Prisma", icon: <SiPrisma size={20} /> },
        { name: "Vercel", icon: <SiVercel size={20} /> },
        { name: "REST APIs", icon: <FaServer size={20} /> },
      ]
    },
    {
      title: "Tools & AI",
      icon: <FaCog size={18} />,
      items: [
        { name: "Git", icon: <DiGit size={26} /> },
        { name: "GitHub", icon: <DiGithubBadge size={26} /> },
        { name: "Cursor AI", icon: <FaRobot size={20} /> },
        { name: "Claude", icon: <FaMagic size={20} /> },
        { name: "Antigravity", icon: <FaSpaceShuttle size={20} /> },
      ]
    }
  ];

  return (
    <section id="skills" className="skills-section">
      <div style={{ maxWidth: '1500px', margin: '0 auto', padding: '0 24px' }}>
        <div className="text-center mb-5 reveal">
          <div className="section-label" style={{ justifyContent: 'center' }}>Stack</div>
          <h2 style={{ fontSize: 'clamp(1.8rem, 4vw, 2.8rem)', fontWeight: 800, letterSpacing: '-0.04em', marginBottom: '0.75rem' }}>
            Mis <span className="text-gradient">Habilidades</span>
          </h2>
          <p style={{ color: 'var(--text-secondary)', maxWidth: '460px', margin: '0 auto', fontSize: '0.95rem' }}>
            Las herramientas que uso día a día para construir productos digitales.
          </p>
        </div>

        <div className="skills-grid-wrapper reveal">
          {categories.map((cat, idx) => (
            <div key={idx} className="skill-category-card spotlight-card">
              <div className="skill-category-header">
                <div className="skill-category-icon">{cat.icon}</div>
                <span className="skill-category-title">{cat.title}</span>
                <span className="skill-category-count">{cat.items.length} skills</span>
              </div>
              <div className="skill-items-grid">
                {cat.items.map((skill, sIdx) => (
                  <div key={sIdx} className="skill-item">
                    <span className="skill-icon">{skill.icon}</span>
                    <span className="skill-name">{skill.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;